
import styles from './ActivityHistory.module.scss';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import common from '../../../common';

import { useSelector } from 'react-redux';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function ActivityHistory() {

    const { pToast, useAlert, useModal, useConfirm, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pModal, ModalComponent} = useModal();
    const { pConfirm, ConfirmComponent} = useConfirm();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [data, setData] = useState({});

    // 년도 그랩
    const currentYear = new Date().getFullYear();
    const [activeYear, setActiveYear] = useState(2024); // 활성화된 연도를 추적하는 상태 원래 currentYear
    const scrollRef = useRef(null);
    let isDown = false;
    let startX;
    let scrollLeft;

    const mouseDownHandler = (e) => {
        isDown = true;
        scrollRef.current.classList.add(styles.active);
        startX = e.pageX - scrollRef.current.offsetLeft;
        scrollLeft = scrollRef.current.scrollLeft;
    };

    const mouseLeaveHandler = () => {
        isDown = false;
        scrollRef.current.classList.remove(styles.active);
    };

    const mouseUpHandler = () => {
        isDown = false;
        scrollRef.current.classList.remove(styles.active);
    };

    const mouseMoveHandler = (e) => {
        if (!isDown) return; // if mouse is not down, return
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 2; // The multiplier controls the scroll speed
        scrollRef.current.scrollLeft = scrollLeft - walk;
    };

    const [years, setYears] = useState([]);
    const [eventsYM, setEventsYM] = useState([]);

    useEffect(() => {
        const tempYears = [
            2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015,
            2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005
        ];

        const tempEventsYM = [
            {
                year: 2005,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.29', description: '2005년 신년회' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.12', description: '전체모임' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.02', description: '제1회 독서모임 (서울대학교)' },
                            { dateTxt: '04.03', description: '제1회 YEHS 정기세미나 (서울대학교)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.14', description: '제2회 독서모임 (서울대학교)' },
                            { dateTxt: '05.21', description: 'YEHS 야유회 (에버랜드)' },
                            { dateTxt: '05.28', description: '제2회 YEHS 정기세미나 (한국기술센터)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.25', description: '제3회 YEHS 정기세미나 (서울대학교)' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.06', description: 'YEHS 산업체방문 및 천경준 부사장님 강연 (삼성전자)' },
                            { dateTxt: '07.16', description: '제4회 YEHS 정기세미나 (서울대학교)' },
                            { dateTxt: '07.30', description: '제5회 YEHS 정기세미나 (서울대학교)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.18', description: 'YEHS 산업체방문 및 조정남 부회장님 강연 (SK Telecom)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.05', description: '제7회 YEHS 정기세미나 (서강대학교)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.17', description: '제8회 YEHS 정기세미나 (서강대학교)' },
                            { dateTxt: '12.28', description: '2005년 YEHS 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2006,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.21', description: '전체모임' }
                        ]
                    },
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.10-12', description: '제1회 주니어 공학기술교실 (연당초등학교)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.25', description: '제9회 YEHS 정기세미나 (연세대학교)' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.29', description: '제10회 YEHS 정기세미나 (이화여자대학교)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.27', description: '제11회 YEHS 정기세미나 (한국기술센터)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.30-07.02', description: '제2회 주니어 공학기술교실 (시초초등학교)' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.20', description: 'YEHS 산업체방문 (현대건설 기술연구소)' },
                            { dateTxt: '07.28-30', description: '제12회 YEHS 정기세미나 (POSTECH)' },
                            { dateTxt: '07.29', description: 'YEHS 산업체방문 (POSCO)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.18-19', description: '제1회 차세대리더 워크샵 (국제청소년센터-드림텔)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.15-17', description: '제3회 주니어 공학기술교실 (나포초등학교)' }
                        ]
                    }
                ]
            },            
            {
                year: 2007,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.06', description: '제12회 YEHS 세미나 (한양대학교)' }
                        ]
                    },
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.09', description: '제4회 주니어 공학기술교실 (지촌초등학교 지암분교)' },
                            { dateTxt: '02.21', description: 'YEHS CEO 간담회 (윤종용 공학한림원 회장)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.03', description: '제13회 YEHS 정기세미나 (서울대학교)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.12', description: '제14회 YEHS 정기세미나 (동국대학교)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.23', description: 'YEHS Senior 발대식' },
                            { dateTxt: '06.28', description: '2007 YEHS 산업체방문 (현대자동차 남양연구소)' },
                            { dateTxt: '06.29', description: '제5회 주니어 공학기술교실 (서석초등학교 청량분교)' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.13', description: 'YEHS 리더십강좌 (KAIST)' },
                            { dateTxt: '07.14', description: '제6회 주니어 공학기술교실 (중앙초등학교)' },
                            { dateTxt: '07.14', description: '제15회 YEHS 정기세미나-토론식 (KAIST)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.08', description: '제7회 주니어 공학기술교실 (횡성 서원초등학교)' },
                            { dateTxt: '09.16', description: '제16회 YEHS 정기세미나-토론식 (고려대학교)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.02', description: '제8회 주니어 공학기술교실 (인제초등학교 가리산분교)' },
                            { dateTxt: '11.10', description: '제17회 YEHS 정기세미나 (이화여자대학교)' },
                            { dateTxt: '11.23', description: 'YEHS CEO 간담회 (한규환 현대모비스 부회장)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.28', description: '2007년 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2008,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.26', description: '제18회 YEHS 정기세미나 (아주대학교)' }
                        ]
                    },
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.13', description: '제1회 고교방문전공설명회 (여의도여자고등학교)' },
                            { dateTxt: '02.15', description: '제9회 주니어 공학기술교실 (제천 남천초등학교)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.15', description: '제19회 YEHS 정기세미나 (연세대학교)' },
                            { dateTxt: '03.28-29', description: '제10회 주니어 공학기술교실 (인제 신평초등학교)' },
                            { dateTxt: '03.28-29', description: '제11회 주니어 공학기술교실 (인제 운암초등학교)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.10', description: '제20회 YEHS 정기세미나 (서강대학교)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.07', description: '제2회 고교방문전공설명회 (영동고등학교)' },
                            { dateTxt: '06.27', description: '제12회 주니어 공학기술교실 및 전공설명회 (전북 남원시청)' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.11', description: 'YEHS CEO 간담회 (최승철 두산인프라코어 부회장)' },
                            { dateTxt: '07.26', description: '제21회 YEHS 정기세미나 (서울대학교)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.20', description: '하계 MT (청평)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.20', description: '제22회 YEHS 정기세미나 (고려대학교)' },
                            { dateTxt: '09.24', description: '제23회 YEHS 정기세미나 (서울대학교)' }
                        ]
                    },
                    {
                        month: 10,
                        detail: [
                            { dateTxt: '10.02-03', description: '제13회 주니어 공학기술교실 (강화 삼산초등학교)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.15', description: '제24회 YEHS 정기세미나 (이화여자대학교)' },
                            { dateTxt: '11.28-29', description: '제14회 주니어 공학기술교실 (인제초등학교 가리산분교)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.23', description: '2008 YEHS 산업체 방문 (국가정보원)' },
                            { dateTxt: '12.23', description: 'YEHS CEO 간담회 (김영학 지식경제부 차관)' },
                            { dateTxt: '12.29', description: '2008년 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2009,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.03-04', description: '제15회 주니어 공학기술교실 (강원 인제군)' },
                            { dateTxt: '01.10', description: '제25회 YEHS 정기세미나 (고려대학교)' }
                        ]
                    },
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.02', description: 'YEHS 상반기 신입회원 오리엔테이션' },
                            { dateTxt: '02.13-14', description: '제16회 주니어 공학기술교실 (충북 음성군)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.28', description: '제26회 YEHS 정기세미나 (서울대학교)' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.04-05', description: '제17회 주니어 공학기술교실 (경상북도 문경시)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.22', description: 'YEHS 리더십강좌: 무엇을 쓸 것인가' },
                            { dateTxt: '05.23', description: '제27회 YEHS 정기세미나 (중앙대학교)' },
                            { dateTxt: '05.29', description: 'YEHS 리더십강좌: 어떻게 쓸 것인가' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.19', description: 'YEHS 리더십강좌: 커뮤니케이션 스킬(1)' },
                            { dateTxt: '06.25', description: 'YEHS 리더십강좌: 커뮤니케이션 스킬(2)' },
                            { dateTxt: '06.26-28', description: '제18회 주니어 공학기술교실 (평창 거문초등학교)' },
                            { dateTxt: '06.26-28', description: '제28회 YEHS 정기세미나 (평창)' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.03', description: 'YEHS 리더십강좌: Trend Watching' },
                            { dateTxt: '07.10', description: 'YEHS 리더십강좌: Presentation Skill(1)' },
                            { dateTxt: '07.14', description: '제3회 고교방문전공설명회 (덕성여자고등학교)' },
                            { dateTxt: '07.17', description: 'YEHS 리더십강좌: Presentation Skill(2)' },
                            { dateTxt: '07.18', description: '제4회 고교방문전공설명회 (인하대학교)' },
                            { dateTxt: '07.24', description: 'YEHS 리더십강좌: Presentation Skill(3)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.01', description: '제29회 YEHS 정기세미나 (연세대학교)' },
                            { dateTxt: '08.17', description: '제19회 주니어 공학기술교실 (서울시 강남구)' },
                            { dateTxt: '08.19', description: '제20회 주니어 공학기술교실 (서울시 강북구)' },
                            { dateTxt: '08.21', description: 'YEHS 하반기 신입회원 오리엔테이션' },
                            { dateTxt: '08.27', description: 'YEHS CEO 특강 (안현실 한경 논설위원)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.18', description: '제21회 주니어 공학기술교실 (정선 여량초등학교)' },
                            { dateTxt: '09.26', description: '제30회 YEHS 정기세미나 (서울대학교)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.21', description: '제22회 주니어 공학기술교실 (경상남도 김해시)' },
                            { dateTxt: '11.27', description: 'YEHS CEO 특강 (조현정 비트컴퓨터 회장)' },
                            { dateTxt: '11.28', description: '제31회 YEHS 정기세미나 (연세대학교)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.30', description: '2009년 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2010,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.30', description: '제32회 YEHS 정기세미나 (한국기술센터)' }
                        ]
                    },
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.08', description: '제5회 고교방문전공설명회 (마포고등학교)' },
                            { dateTxt: '02.19', description: '제23회 주니어 공학기술교실 (전북 무주군)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.27', description: '제33회 YEHS 정기세미나 (연세대학교)' },
                            { dateTxt: '03.27', description: '제24회 주니어 공학기술교실 (서울시 양천구)' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.03', description: '제25회 주니어 공학기술교실 (가평 연하초등학교)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.07', description: '제6회 고교방문전공설명회 (안양 인덕원고등학교)' },
                            { dateTxt: '05.14', description: 'YEHS CEO 특강 (정동수 율촌 고문)' },
                            { dateTxt: '05.22', description: '제1회 YEHS 체육대회 (서울숲)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.12', description: '제7회 고교방문전공설명회 (하나고등학교)' },
                            { dateTxt: '06.24-25', description: '제34회 YEHS 정기세미나 (POSTECH)' },
                            { dateTxt: '06.24-25', description: '제26회 주니어 공학기술교실 (충청북도 제천시)' },
                            { dateTxt: '06.24-25', description: 'YEHS 산업체방문 (현대중공업, POSCO)' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.07', description: '제8회 고교방문전공설명회(서울 마포고등학교)' },
                            { dateTxt: '07.09', description: 'YEHS 리더십강좌: 글쓰기(1)' },
                            { dateTxt: '07.13', description: 'YEHS 리더십강좌: 글쓰기(2)' },
                            { dateTxt: '07.16', description: 'YEHS 리더십강좌: 인간관계에서의 심리학' },
                            { dateTxt: '07.20', description: 'YEHS 리더십강좌: 20대를 위한 마음경영' },
                            { dateTxt: '07.23', description: 'YEHS 리더십강좌: 커뮤니케이션? 공구(tool)도 모르면서' },
                            { dateTxt: '07.24', description: '제35회 YEHS 정기세미나 (서강대학교)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.17', description: '제27회 주니어 공학기술교실 (서울시 용산구)' },
                            { dateTxt: '08.21', description: '제28회 주니어 공학기술교실 (서울시 강남구)' },
                            { dateTxt: '08.26', description: '제9회 고교방문전공설명회 (평택 신한고등학교)' },
                            { dateTxt: '08.28', description: 'YEHS CEO 특강 (김도연 울산대학교 총장)' }
                        ]
                    },
                    {
                        month: 10,
                        detail: [
                            { dateTxt: '10.30', description: '제36회 YEHS 세미나 (서울대학교)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.06-07', description: '제29회 주니어 공학기술교실 (충청북도 괴산군)' },
                            { dateTxt: '11.20', description: '제30회 주니어 공학기술교실 (서울시 송파구)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.04', description: '제37회 YEHS 세미나 (고려대학교)' },
                            { dateTxt: '12.28', description: '2010년 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2011,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.02', description: '제10회 고교방문전공설명회 (수지고등학교)' },
                            { dateTxt: '01.22', description: '제38회 YEHS 정기세미나 (이화여자대학교)' }
                        ]
                    },
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.18', description: '제31회 주니어 공학기술교실(서울시 관악구)' },
                            { dateTxt: '02.24-26', description: '제32회 주니어 공학기술교실(전남 해남군)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.26', description: '제39회 YEHS 정기세미나' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.15-16', description: '제11회 고교방문전공설명회 (문현여자고등학교)' },
                            { dateTxt: '04.15-16', description: '제12회 고교방문전공설명회 (해운대고등학교)' },
                            { dateTxt: '04.15-16', description: '제13회 고교방문전공설명회 (한국과학영재학교)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.21', description: '제40회 YEHS 정기세미나 (서울대학교)' },
                            { dateTxt: '05.28', description: '제2회 YEHS 체육대회 (서강대학교)' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.01-03', description: '제33회 주니어 공학기술교실(강원도 동해시)' },
                            { dateTxt: '07.02', description: '제41회 YEHS 정기세미나(강원도 동해시)' },
                            { dateTxt: '07.06-08', description: 'YEHS 리더십캠프 (안성 너리굴 문화마을)' },
                            { dateTxt: '07.22', description: 'YEHS 리더십강좌: 이공계생의 글쓰기(1)' },
                            { dateTxt: '07.29', description: 'YEHS 리더십강좌: 이공계생의 글쓰기(2)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.19', description: 'YEHS 리더십강좌: 한 방에 먹히는 자기표현 전략' },
                            { dateTxt: '08.20', description: '2011 YEHS 상반기 신입회원 오리엔테이션' },
                            { dateTxt: '08.25', description: 'YEHS 산업체방문 (현대자동차 남양연구소, 현대제철)' },
                            { dateTxt: '08.26', description: 'YEHS 리더십강좌: 영화 속의 협상 전략' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.24', description: '제34회 주니어 공학기술교실 (서울시 성북구)' }
                        ]
                    },
                    {
                        month: 10,
                        detail: [
                            { dateTxt: '10.01', description: '제35회 주니어 공학기술교실 (서울시 노원구)' },
                            { dateTxt: '10.12', description: '제42회 YEHS 정기세미나 (부산 조선비치호텔)' },
                            { dateTxt: '10.29', description: '제43회 YEHS 오픈세미나 (이화여자대학교)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.04-06', description: '제36회 주니어 공학기술교실 (경주 신라초등학교)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.22', description: '제14회 고교방문전공설명회 (중앙대 사범대학 부속고등학교)' },
                            { dateTxt: '12.29', description: '2011년 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2012,
                events: [
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.04', description: 'YEHS 상반기 신입회원 오리엔테이션' },
                            { dateTxt: '02.18', description: '제44회 YEHS 정기세미나 (고려대학교)' },
                            { dateTxt: '02.20', description: '제37회 주니어 공학기술교실 (서울시 용산구)' },
                            { dateTxt: '02.22', description: 'YEHS CEO 간담회 (홍석우 지식경제부 장관)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.17', description: '제38회 주니어 공학기술교실 (서울시 양천구)' },
                            { dateTxt: '03.30', description: '제15회 고교방문전공설명회 (효성고등학교)' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.07', description: '제39회 주니어 공학기술교실 (공주시)' },
                            { dateTxt: '04.28', description: '제45회 YEHS 정기세미나 (홍익대학교)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.19', description: '제3회 YEHS 체육대회 (여의도 한강공원)' },
                            { dateTxt: '05.30', description: '제16회 고교방문전공설명회 (한성여자고등학교)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.02', description: '제46회 YEHS 정기세미나 (한양대학교)' },
                            { dateTxt: '06.20', description: '제17회 고교방문전공설명회 (경희여자고등학교)' },
                            { dateTxt: '06.29', description: 'YEHS 리더십강좌 (CEO 지식나눔 재단)' },
                            { dateTxt: '06.30', description: '제1회 YEHS 홈커밍데이' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.06', description: 'YEHS 리더십강좌 (CEO 지식나눔 재단)' },
                            { dateTxt: '07.13', description: '제18회 고교방문전공설명회 (강화여자고등학교)' },
                            { dateTxt: '07.13', description: '제19회 고교방문전공설명회 (강화고등학교)' },
                            { dateTxt: '07.14', description: '제40회 주니어 공학기술교실 (삼산승영중학교학교)' },
                            { dateTxt: '07.27', description: '제20회 고교방문전공설명회 (광양제철고등학교)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.04', description: '제47회 YEHS 오픈세미나 (이화여자대학교)' },
                            { dateTxt: '08.17', description: 'YEHS 리더십강좌: 자신만의 삶의 방식' },
                            { dateTxt: '08.24', description: '제41회 주니어 공학기술교실 (성동구 라온지역 아동센터)' },
                            { dateTxt: '08.24', description: 'YEHS 리더십강좌: 급변하는 기술융합시대에서의 기술경영의 중요성' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.01', description: '제21회 고교방문전공설명회 (글말캠전공설명회)' },
                            { dateTxt: '09.22', description: '제48회 YEHS 정기세미나 (중앙대학교)' },
                            { dateTxt: '09.26', description: '제42회 주니어 공학기술교실 (시함창중학교)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.10', description: '제49회 YEHS 정기세미나 (고려대학교)' },
                            { dateTxt: '11.12', description: '제43회 주니어 공학기술교실 (부천 중흥중학교)' },
                            { dateTxt: '11.16', description: '제44회 주니어 공학기술교실 (파주 광탄중학교)' },
                            { dateTxt: '11.21', description: '제45회 주니어 공학기술교실 (서산여자중학교)' },
                            { dateTxt: '11.23', description: '제46회 주니어 공학기술교실 (용산 신광여자중학교)' },
                            { dateTxt: '11.30', description: '제47회 주니어 공학기술교실 (완주 용진중학교)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.27', description: '2012년 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2013,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.19', description: '제50회 YEHS 세미나 (중앙대학교)' }
                        ]
                    },
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.02', description: '상반기 신입생 오리엔테이션 (서울대학교)' },
                            { dateTxt: '02.15-16', description: '제48회 주니어 공학기술교실 (칠곡 숭산초등학교)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.09', description: '제51회 YEHS 세미나 (서울대학교)' },
                            { dateTxt: '03.23', description: '제49회 주니어 공학기술교실 (서울 섬기는지역아동센터)' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.05', description: '제22회 고교방문전공설명회 (화성 반송고등학교)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.04', description: '제23회 고교방문전공설명회 (서울 진선여자고등학교)' },
                            { dateTxt: '05.11', description: '제52회 YEHS 정기세미나 (고려대학교)' },
                            { dateTxt: '05.15', description: 'YEHS CEO 간담회 (김영민 특허청장)' },
                            { dateTxt: '05.25', description: '제4회 YEHS 체육대회' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.28-30', description: '제24, 25회 고교방문전공설명회 (제주 사범대학 부설고등학교)' },
                            { dateTxt: '06.28-30', description: '제50회 주니어 공학기술교실 (제주시 조천읍)' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.06', description: '제53회 YEHS 정기세미나 (서강대학교)' },
                            { dateTxt: '07.11', description: '제26회 고교방문전공설명회 (양정고등학교)' },
                            { dateTxt: '07.13', description: '제2회 YEHS 홈커밍데이' },
                            { dateTxt: '07.22', description: 'YEHS 산업체방문 (현대건설기술개발원, 삼성종합기술원)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.08', description: '제51회 주니어 공학기술교실 (서울시 성북구 달맞이공부방)' },
                            { dateTxt: '08.13', description: '제27회 고교방문전공설명회 (글쓰기말하기캠프)' },
                            { dateTxt: '08.30', description: '제52회 주니어 공학기술교실 (대송초등학교)' },
                            { dateTxt: '08.30', description: '제28회 고교방문전공설명회 (포항제철고등학교)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.13', description: '제29회 고교방문전공설명회 (신광여자고등학교)' }
                        ]
                    },
                    {
                        month: 10,
                        detail: [
                            { dateTxt: '10.03', description: 'YEHS 가을소풍' },
                            { dateTxt: '10.05', description: '제54회 YEHS 오픈세미나 (이화여자대학교)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.16', description: '제53회 주니어 공학기술교실 (서울 아현동)' },
                            { dateTxt: '11.17', description: '제55회 YEHS 정기세미나 (홍익대학교)' },
                            { dateTxt: '11.20', description: '제30회 고교방문전공설명회 (한성고등학교)' },
                            { dateTxt: '11.23', description: '제54회 주니어 공학기술교실 (춘천 서상초등학교)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.27', description: '2013 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2014,
                events: [
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.14-15', description: '제55회 주니어 공학기술교실 (세천초등학교)' },
                            { dateTxt: '02.14-15', description: '제56회 YEHS 특별세미나 (대전)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.15', description: '제57회 YEHS 정기세미나 (한양대학교)' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.04', description: '제31회 고교방문전공설명회 (정신여자고등학교)' },
                            { dateTxt: '04.26', description: '제56회 주니어 공학기술교실 (상암동 지역아동센터)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.17', description: '제58회 YEHS 정기세미나 (이화여자대학교)' },
                            { dateTxt: '05.23', description: '제32회 고교방문전공설명회 (신광여자고등학교)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.27-28', description: '제33회 고교방문전공설명회 (거제고등학교)' },
                            { dateTxt: '06.27-28', description: '제34회 고교방문전공설명회 (제일고등학교)' },
                            { dateTxt: '06.27-28', description: '제57회 주니어 공학기술교실 (사등초등학교)' },
                            { dateTxt: '06.27-28', description: '제59회 특별세미나 (거제)' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.10', description: '제58회 주니어 공학기술교실 (송양초등학교)' },
                            { dateTxt: '07.19', description: '제3회 YEHS 홈커밍데이' },
                            { dateTxt: '07.20', description: '제35회 고교방문전공설명회 (글쓰기말하기캠프)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.02', description: '제1회 리더십포럼' },
                            { dateTxt: '08.12-13', description: 'YEHS 산업체방문 (국방연구소, 기계연구원, 항공우주연구원, LG화학)' },
                            { dateTxt: '08.23', description: '제60회 YEHS 정기세미나 (한국기술센터)' },
                            { dateTxt: '08.26', description: '제59회 주니어 공학기술교실 (서울 성동구)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.12', description: '제36회 고교방문전공설명회 (경신고등학교)' },
                            { dateTxt: '09.13', description: '제5회 YEHS 체육대회' }
                        ]
                    },
                    {
                        month: 10,
                        detail: [
                            { dateTxt: '10.11', description: '제60회 주니어 공학기술교실 (서울 성북구)' },
                            { dateTxt: '10.25', description: 'YEHS 리더십강좌: 헬스케어 이노베이션, 디자인 창작의 보호' },
                            { dateTxt: '10.30', description: '제37회 고교방문전공설명회 (부광고등학교)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.01', description: 'YEHS 리더십강좌: 협상의 예술, 미래 아젠다와 공학기술인의 진로' },
                            { dateTxt: '11.08-09', description: '제61회 주니어 공학기술교실 (명신초등학교)' },
                            { dateTxt: '11.08-09', description: '제62회 주니어 공학기술교실 (내가초등학교)' },
                            { dateTxt: '11.15', description: '제61회 YEHS 진로가이드세미나' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.18', description: '제38회 고교방문전공설명회 (창덕여자고등학교)' },
                            { dateTxt: '12.23', description: '제10회 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2015,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.31', description: '제62회 YEHS 정기세미나 (동국대학교)' }
                        ]
                    },
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.05-06', description: '제63회 주니어 공학기술교실 (미원초등학교)' },
                            { dateTxt: '02.05-06', description: '제39회 고교방문전공설명회 (충북과학고등학교)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.21', description: '제63회 YEHS 정기세미나 (서강대학교)' },
                            { dateTxt: '03.27', description: '제40회 고교방문전공설명회 (관악고등학교)' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.11', description: '제64회 주니어 공학기술교실 (시니어)' },
                            { dateTxt: '04.25', description: '제65회 주니어 공학기술교실 (서울시 마포구)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.08', description: '제41회 고교방문전공설명회 (잠신고등학교)' },
                            { dateTxt: '05.09', description: '제6회 YEHS 체육대회 (서울대학교)' },
                            { dateTxt: '05.30', description: '제64회 YEHS 정기세미나 (서울대학교)' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.18', description: '제65회 YEHS 정기세미나 (이화여자대학교)' },
                            { dateTxt: '07.22', description: 'YEHS 산업체방문 (LG디스플레이, 건설기술연구원)' },
                            { dateTxt: '07.25', description: '제66회 주니어 공학기술교실 (서울시 봉천동)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.06', description: '제42회 고교방문전공설명회 (글쓰기말하기캠프)' },
                            { dateTxt: '08.15', description: '제2회 리더십포럼 (이화여자대학교)' },
                            { dateTxt: '08.22', description: '제67회 주니어 공학기술교실 (송천 지역아동센터)' },
                            { dateTxt: '08.22', description: '제68회 주니어 공학기술교실 (아람 지역아동센터)' },
                            { dateTxt: '08.28-30', description: '제69회 주니어 공학기술교실 (남신초등학교)' },
                            { dateTxt: '08.28-30', description: '제43회 고교방문전공설명회 (태안고등학교)' },
                            { dateTxt: '08.28-30', description: '제66회 YEHS 특별세미나 (태안)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.12', description: '제67회 YEHS 진로가이드세미나' }
                        ]
                    },
                    {
                        month: 10,
                        detail: [
                            { dateTxt: '10.17', description: '제44회 초청전공설명회 (공학한림원 창립 20주년 공학한마당)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.06', description: '제45회 고교방문전공설명회 (정신여자고등학교)' },
                            { dateTxt: '11.07', description: '창립 10주년 YEHS 홈커밍데이' },
                            { dateTxt: '11.21', description: '제3회 리더십포럼 (서강대학교)' },
                            { dateTxt: '11.28', description: '제68회 YEHS 정기세미나' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.19-20', description: '제70회 주니어 공학기술교실 (충남 보령)' },
                            { dateTxt: '12.22-23', description: '제46회 고교방문전공설명회 (보령 대천고등학교)' },
                            { dateTxt: '12.23', description: '제11회 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2016,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.30', description: '제69회 YEHS 정기세미나 (연세대학교)' }
                        ]
                    },
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.02-03', description: '제71회 주니어 공학기술교실 (영주 봉현초등학교)' },
                            { dateTxt: '02.02-03', description: '제47회 고교방문전공설명회 (안동 안동고등학교)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.19', description: '제72회 주니어 공학기술교실 (서울 영등포구)' },
                            { dateTxt: '03.26', description: '제70회 YEHS 정기세미나 (한양대학교)' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.01', description: '제48회 고교방문전공설명회 (명지고등학교)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.07', description: '제7회 YEHS 체육대회 (이촌한강공원)' },
                            { dateTxt: '05.28', description: '제71회 YEHS 진로가이드세미나 (낙성대역)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.20', description: '제4회 YEHS 리더십포럼' },
                            { dateTxt: '08.26-28', description: '제73회 주니어 공학기술교실 (경주 강동초등학교)' },
                            { dateTxt: '08.26-28', description: '제49회 고교방문전공설명회 (경주고등학교)' },
                            { dateTxt: '08.26-28', description: '제50회 고교방문전공설명회 (경주여자고등학교)' },
                            { dateTxt: '08.26-28', description: '제72회 YEHS 특별세미나 (경주시)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.10', description: '2016 YEHSociety (홈커밍데이)' },
                            { dateTxt: '09.24', description: '제73회 YEHS 정기세미나 (건국대학교)' }
                        ]
                    },
                    {
                        month: 10,
                        detail: [
                            { dateTxt: '10.22', description: '제51회 초청전공설명회 (안산 사이언스밸리)' },
                            { dateTxt: '10.23', description: '제52회 초청전공설명회 (세계과학문화포럼)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.11', description: '제53회 고교방문전공설명회 (정신여자고등학교)' },
                            { dateTxt: '11.12-13', description: '제74회 주니어 공학기술교실 (강원도 원주)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.22', description: '제12회 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2017,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.21', description: '제74회 YEHS 정기세미나 (고려대학교)' }
                        ]
                    },
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.04-05', description: '제75회 주니어 공학기술교실 (논산 연무초등학교)' },
                            { dateTxt: '02.04-05', description: '제54회 고교방문전공설명회 (논산 대건고등학교)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.11-12', description: '제1회 YEHS Workshop' },
                            { dateTxt: '03.11-12', description: '제77회 주니어 공학기술교실 (인천 선학초등학교)' },
                            { dateTxt: '03.24', description: '제55회 고교방문전공설명회 (과천여자고등학교)' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.01', description: '제75회 YEHS 정기세미나 (성균관대학교)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.06', description: '제80회 주니어 공학기술교실 (부산 가락초등학교)' },
                            { dateTxt: '05.13', description: '제8회 YEHS 체육대회' },
                            { dateTxt: '05.20', description: '제76회 YEHS 진로가이드세미나 (동국대학교)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.02', description: 'YEHS 홍콩과기대학 교류전' },
                            { dateTxt: '06.24', description: '제5회 리더십포럼' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.20-21', description: '제78회 주니어 공학기술교실 (강릉 율곡초등학교)' },
                            { dateTxt: '07.20-21', description: '제56회 고교방문전공설명회 (강릉 명륜고등학교)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.12', description: '제77회 YEHS 오픈세미나 (고려대학교)' },
                            { dateTxt: '08.18', description: 'YEHS & YIPL 브레인스토밍 (동국대학교)' },
                            { dateTxt: '08.29', description: '제79회 주니어 공학기술교실 (서울 면목)' },
                            { dateTxt: '08.31', description: '제57회 고교방문전공설명회 (동대부고)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.01', description: '제58회 고교방문전공설명회 (보인고등학교)' },
                            { dateTxt: '09.17', description: '2017 YEHSociety (홈커밍데이)' },
                            { dateTxt: '09.23', description: '제78회 YEHS 정기세미나 (한양대학교)' },
                            { dateTxt: '09.26-27', description: '제80회 주니어 공학기술교실 (부산 가락초등학교)' },
                            { dateTxt: '09.26-27', description: '제2회 YEHS 토론회: Smart City' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.18', description: '제6회 리더십포럼' },
                            { dateTxt: '11.20', description: '제59회 고교방문전공설명회 (선덕고등학교)' },
                            { dateTxt: '11.24', description: '제81회 주니어 공학기술교실 (서울 관악구)' },
                            { dateTxt: '11.25', description: '제79회 YEHS 정기세미나 (서울대학교)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.22', description: '제13회 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2018,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.27', description: '제80회 YEHS 정기세미나 (건국대학교)' }
                        ]
                    },
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.02-03', description: '제82회 주니어 공학기술교실 (전주 대정초등학교)' },
                            { dateTxt: '02.02-03', description: '제83회 주니어 공학기술교실 (전주 평화초등학교)' },
                            { dateTxt: '02.02-03', description: '제60회 고교방문전공설명회 (전북과학고등학교)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.10-11', description: '제2회 YEHS Workshop' },
                            { dateTxt: '03.10-11', description: '제84-86회 주니어 공학기술교실 (화성시)' },
                            { dateTxt: '03.24', description: '제81회 YEHS 정기세미나 (이화여자대학교)' },
                            { dateTxt: '03.28', description: '제61회 고교방문전공설명회 (숭문고등학교)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.09', description: '제62회 고교방문전공설명회 (숭의여자고등학교)' },
                            { dateTxt: '05.12', description: '제82회 진로가이드세미나 (서강대학교)' },
                            { dateTxt: '05.18', description: '제63회 고교방문전공설명회 (신광여자고등학교)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.01', description: '제87-89회 주니어 공학기술교실 (POSCO 봉사단)' },
                            { dateTxt: '06.19', description: '제90회 주니어 공학기술교실 (목운초등학교)' },
                            { dateTxt: '06.23', description: '제7회 리더십포럼' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.04', description: 'YEHS 산업체방문 (LG화학, SK하이닉스)' },
                            { dateTxt: '07.06', description: '제91회 주니어 공학기술교실 (방이초등학교)' },
                            { dateTxt: '07.13', description: '제64회 고교방문전공설명회 (영파여자고등학교)' },
                            { dateTxt: '07.16', description: '제65회 고교방문전공설명회 (서현고등학교)' },
                            { dateTxt: '07.18', description: '제66회 고교방문전공설명회 (영등포고등학교)' },
                            { dateTxt: '07.31', description: '제92회 주니어 공학기술교실 (안양시)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.11', description: '제83회 YEHS 오픈세미나 (연세대학교)' },
                            { dateTxt: '08.23-25', description: '제93-95회 주니어 공학기술교실 (포항)' },
                            { dateTxt: '08.23-25', description: '제67회 고교방문전공설명회 (포항 대동고등학교)' },
                            { dateTxt: '08.23-25', description: '제68회 고교방문전공설명회 (포항제철고등학교)' },
                            { dateTxt: '08.23-25', description: 'YEHS 산업체방문 (POSCO)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.15', description: '2018 YEHSociety (홈커밍데이)' },
                            { dateTxt: '09.19', description: '제69회 고교방문전공설명회 (예일여자고등학교)' },
                            { dateTxt: '09.29', description: '제84회 YEHS 정기세미나 (서울대학교)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.07', description: '제99회 주니어 공학기술교실 (송천초등학교)' },
                            { dateTxt: '11.09', description: '제100회 주니어 공학기술교실 (불암초등학교)' },
                            { dateTxt: '11.16', description: '제1회 중등공학체험교실 (무학중학교)' },
                            { dateTxt: '11.17', description: '제70회 고교방문전공설명회 (은평고등학교)' },
                            { dateTxt: '11.17', description: '제8회 YEHS&YIPL 리더십포럼' },
                            { dateTxt: '11.23', description: '제2회 중등공학체험교실 (아주중학교)' },
                            { dateTxt: '11.24', description: '제85회 YEHS 정기세미나 (고려대학교)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.20', description: '제71회 고교방문전공설명회 (대성고등학교)' },
                            { dateTxt: '12.22', description: '제14회 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2019,
                events: [
                    {
                        month: 1,
                        detail: [
                            { dateTxt: '01.26', description: '제86회 YEHS 정기세미나 (한양대학교)' }
                        ]
                    },
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.08-09', description: '제72회 고교방문전공설명회 (속초고등학교)' },
                            { dateTxt: '02.08-09', description: '제101-102회 주니어 공학기술교실 (속초시)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.09-10', description: '제3회 YEHS Workshop' },
                            { dateTxt: '03.09-10', description: '제103-105회 주니어 공학기술교실 (광명시)' },
                            { dateTxt: '03.09-10', description: '제73회 고교방문전공설명회 (시흥매화고등학교)' },
                            { dateTxt: '03.16', description: '제74회 고교방문전공설명회 (경북과학고등학교)' },
                            { dateTxt: '03.22', description: '제75회 고교방문전공설명회 (대성고등학교)' },
                            { dateTxt: '03.23', description: '제106회 주니어 공학기술교실 (대전 성룡초등학교)' },
                            { dateTxt: '03.28', description: '제107-1,2,3회 주니어 공학기술교실 (마장동)' },
                            { dateTxt: '03.30', description: '제87회 YEHS 정기세미나 (서강대학교)' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.13-14', description: '제108회 주니어 공학기술교실 (서울과학축전)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.11', description: '제109회 주니어 공학기술교실 (KIST)' },
                            { dateTxt: '05.15', description: '제3회 중등공학체험교실 (수원 이목중학교)' },
                            { dateTxt: '05.18', description: '제88회 YEHS 진로가이드세미나 (강남 비포럼)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.22', description: '제9회 YEHS&YIPL 리더십포럼 (연세대학교)' },
                            { dateTxt: '06.23-28', description: '제110-114회 주니어 공학기술교실 (광양시)' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.05', description: '제76회 고교방문전공설명회 (이매고등학교)' },
                            { dateTxt: '07.11', description: '제4회 중등공학체험교실 (서울 중화중학교)' },
                            { dateTxt: '07.15', description: '제77회 고교방문전공설명회 (경기고등학교)' },
                            { dateTxt: '07.17', description: 'YEHS 산업체방문 (ETRI, 한국에너지기술연구원, 귀뚜라미)' },
                            { dateTxt: '07.27', description: '제1회 YEHS Step-up Day (서울대학교)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.03', description: '제89회 YEHS 오픈세미나 (이화여자대학교)' },
                            { dateTxt: '08.22', description: '제90회 YEHS 특별세미나 (한양대학교)' },
                            { dateTxt: '08.23', description: '제5회 중등공학체험교실 (서울 무학중학교)' },
                            { dateTxt: '08.28', description: '제6회 중등공학체험교실 (안산 성포중학교)' },
                            { dateTxt: '08.30-09.01', description: '제78회 고교방문전공설명회 (광양제철고등학교)' },
                            { dateTxt: '08.30-09.01', description: '제79회 고교방문전공설명회 (순천고등학교)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.19', description: '제80회 고교방문전공설명회 (대전대성고등학교)' },
                            { dateTxt: '09.20', description: '제115-1,2,3회 주니어 공학기술교실 (서울 대립동)' },
                            { dateTxt: '09.22', description: '2019 YEHSociety (홈커밍데이)' },
                            { dateTxt: '09.28', description: '제91회 YEHS 정기세미나 (동국대학교)' }
                        ]
                    },
                    {
                        month: 10,
                        detail: [
                            { dateTxt: '10.19', description: '제7회 중등공학체험교실 (안산 사이언스밸리)' },
                            { dateTxt: '10.19', description: '고교전공설명회 (안산 사이언스밸리)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.05', description: '제81회 고교방문전공설명회 (용화여자고등학교)' },
                            { dateTxt: '11.08', description: '제8회 중등공학체험교실 (안산 경수중학교)' },
                            { dateTxt: '11.09', description: '제10회 YEHS&YIPL 리더십포럼 (서강대학교)' },
                            { dateTxt: '11.22', description: '제116회 주니어 공학기술교실 (서울 장평초등학교)' },
                            { dateTxt: '11.30', description: '제92회 YEHS 정기세미나 (고려대학교)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.21', description: '제15회 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2020,
                events: [
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.01', description: '제93회 YEHS 정기세미나 (한양대학교)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.21', description: '제118회 주니어 공학기술교실 (서울시)' },
                            { dateTxt: '05.22', description: '제119회 주니어 공학기술교실 (시흥시)' },
                            { dateTxt: '05.23', description: '제1회 온라인 전공설명회 (온라인)' },
                            { dateTxt: '05.30', description: '제94회 YEHS 진로가이드세미나 (온라인)' },
                            { dateTxt: '05.31', description: '제95회 YEHS 유학세미나 (온라인)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.27', description: '제11회 YEHS&YIPL 리더십포럼' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.08', description: '제120회 주니어 공학기술교실 (화성 새강지역아동센터)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.08-09.05', description: '제1회 YEHS 메이커톤 (서울대학교, 온라인)' },
                            { dateTxt: '08.27-28', description: '제121-124회 주니어 공학기술교실 (서울, 수원, 동탄)' },
                            { dateTxt: '08.29', description: '제96회 YEHS 정기세미나 (온라인)' },
                            { dateTxt: '08.29', description: '제125회 주니어 공학기술교실 (서울 금천구)' },
                            { dateTxt: '08.31', description: '제126회 주니어 공학기술교실 (서울)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.12', description: '제2회 온라인전공설명회 (온라인)' },
                            { dateTxt: '09.26', description: '제97회 YEHS 정기세미나 (온라인)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.06-07', description: '제127-130회 주니어 공학기술교실 (안산시)' },
                            { dateTxt: '11.06-07', description: '제82회 고교방문전공설명회 (새솔고등학교)' },
                            { dateTxt: '11.13-14', description: '제131-134회 주니어 공학기술교실 (포항시)' },
                            { dateTxt: '11.13-14', description: '제83회 고교방문전공설명회 (경북과학고등학교)' },
                            { dateTxt: '11.14', description: '제12회 YEHS&YIPL 리더십포럼' },
                            { dateTxt: '11.28', description: '제98회 YEHS 정기세미나 (온라인)' },
                            { dateTxt: '11.29', description: '제84회 고교방문전공설명회 (과학책방갈다)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.19', description: '제16회 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2021,
                events: [
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.06', description: '제99회 YEHS 정기세미나 (온라인)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.20', description: '제100회 YEHS 정기세미나 (온라인)' },
                            { dateTxt: '03.20', description: '제101회 YEHS 진로가이드세미나 (온라인)' },
                            { dateTxt: '03.22', description: '제1회 Remember YEHS (온라인)' },
                            { dateTxt: '03.30', description: '제135회 주니어 공학기술교실 (충남 태안)' }
                        ]
                    },
                    {
                        month: 4,
                        detail: [
                            { dateTxt: '04.02', description: '제85회 고교방문전공설명회 (대전 만년고등학교)' },
                            { dateTxt: '04.07', description: '제136회 주니어 공학기술교실 (제주 담쟁이지역아동센터)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.06', description: '제137회 주니어 공학기술교실 (거제 YMCA 지역아동센터)' },
                            { dateTxt: '05.10', description: '제138회 주니어 공학기술교실 (거제 일운지역아동센터)' },
                            { dateTxt: '05.12', description: '제139회 주니어 공학기술교실 (목포 꿈나무지역아동센터)' },
                            { dateTxt: '05.13', description: '제140회 주니어 공학기술교실 (강릉 사임당지역아동센터)' },
                            { dateTxt: '05.14', description: '제141회 주니어 공학기술교실 (태안 솔로몬지역아동센터)' },
                            { dateTxt: '05.26', description: '제142회 주니어 공학기술교실 (거제 둔덕골지역아동센터)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.26', description: '제13회 YEHS&YIPL 리더십포럼' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.10', description: '제86회 고교방문전공설명회 (경북과학고등학교)' },
                            { dateTxt: '07.21', description: '제87회 고교방문전공설명회 (대성고등학교)' },
                            { dateTxt: '07.31', description: '제102회 YEHS 유학세미나 (온라인)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.26', description: '2021 YEHS 아이디어톤 (온라인)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.10', description: '제143회 주니어 공학기술교실 (전주 아이들천국지역아동센터)' },
                            { dateTxt: '09.11', description: '제103회 YEHS 정기세미나 (온라인)' },
                            { dateTxt: '09.17', description: '제144회 주니어 공학기술교실 (서울 대림구립 동지역아동센터)' },
                            { dateTxt: '09.29', description: '제145회 주니어 공학기술교실 (전북 부안꿈터 지역아동센터)' }
                        ]
                    },
                    {
                        month: 10,
                        detail: [
                            { dateTxt: '10.01', description: '제104회 특별세미나 (온라인)' },
                            { dateTxt: '10.01', description: '제146회 주니어 공학기술교실 (서울 조이스터디지역아동센터)' },
                            { dateTxt: '10.01', description: '제147회 주니어 공학기술교실 (충북 금릉지역아동센터)' },
                            { dateTxt: '10.30', description: '2021 YEHS 공학 골든벨 (온라인)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.08', description: '제148회 주니어 공학기술교실 (전주 화목지역아동센터)' },
                            { dateTxt: '11.13', description: '제14회 YEHS&YIPL 리더십포럼' },
                            { dateTxt: '11.23-25', description: '제149-150회 주니어 공학기술교실 (서울 동작구)' },
                            { dateTxt: '11.27', description: '제105회 YEHS 정기세미나 (한양대학교)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.23', description: '2021 제17회 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2022,
                events: [
                    {
                        month: 2,
                        detail: [
                            { dateTxt: '02.12', description: '제106회 YEHS 정기세미나 (온라인)' },
                            { dateTxt: '02.24', description: '제88회 고교방문전공설명회 (안양 신성고등학교)' }
                        ]
                    },
                    {
                        month: 3,
                        detail: [
                            { dateTxt: '03.18', description: '제151회 주니어 공학기술교실 (함안군 공립형 아동센터)' },
                            { dateTxt: '03.25', description: '제89회 고교방문전공설명회 (서울 효문고등학교)' },
                            { dateTxt: '03.26', description: '제107회 YEHS 정기세미나 (온라인)' }
                        ]
                    },
                    {
                        month: 5,
                        detail: [
                            { dateTxt: '05.18', description: '제90회 고교방문전공설명회 (여수 한영고등학교, 온라인)' }
                        ]
                    },
                    {
                        month: 6,
                        detail: [
                            { dateTxt: '06.25', description: '제15회 차세대 테크 리더십포럼 (서울대학교)' }
                        ]
                    },
                    {
                        month: 7,
                        detail: [
                            { dateTxt: '07.08-09', description: '제153-155회 주니어 공학기술교실 (포항시)' },
                            { dateTxt: '07.08-09', description: '제91회 고교방문전공설명회 (포항 경북과학고등학교)' },
                            { dateTxt: '07.16', description: '제108회 YEHS 유학세미나 (온라인)' },
                            { dateTxt: '07.18', description: '제92회 고교방문전공설명회 (서울 대성고등학교)' }
                        ]
                    },
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.06-27', description: '2022 YEHS 아이디어톤 (연세대학교)' },
                            { dateTxt: '08.20', description: '제109회 YEHS 진로가이드세미나 (연세대학교)' },
                            { dateTxt: '08.26', description: '제93회 고교방문전공설명회 (서울 숭문고등학교)' }
                        ]
                    },
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.17', description: '제110회 YEHS 특별세미나 (연세대학교)' },
                            { dateTxt: '09.24-25', description: '안산 사이언스밸리 주니어 공학기술교실 (한양대학교 ERICA)' }
                        ]
                    },
                    {
                        month: 11,
                        detail: [
                            { dateTxt: '11.05', description: '제16회 차세대 테크 리더십포럼 (COEX)' },
                            { dateTxt: '11.11-12', description: '제156-159회 주니어 공학기술교실 (전남 여수시)' },
                            { dateTxt: '11.19', description: '제111회 YEHS 정기세미나 (한양대학교)' }
                        ]
                    },
                    {
                        month: 12,
                        detail: [
                            { dateTxt: '12.23', description: '제18회 YEHS 정기총회 및 송년회' }
                        ]
                    }
                ]
            },
            {
                year: 2023,
                events: [
                    {
                        month: 8,
                        detail: [
                            { dateTxt: '08.12', description: '제100회 고교방문 전공설명회 (여수 한영고등학교)' }
                        ]
                    }
                ]
            },
            {
                year: 2024,
                events: [
                    {
                        month: 9,
                        detail: [
                            { dateTxt: '09.21', description: 'YEHS 창립 20주년 YEHSociety' },
                        ]
                    }
                ]
            }
        ];
        setYears(tempYears);
        setEventsYM(tempEventsYM);
    }, []);


    const filteredEvents = eventsYM.find(event => event.year === activeYear);

    return (
        <>
            <div className="components_wrap">
                <span className='components_wrap_title'>활동연혁</span>

                <div className={styles.history_box}>
                    <div
                        className={styles.history_year_box}
                        ref={scrollRef} onMouseDown={mouseDownHandler} onMouseLeave={mouseLeaveHandler} onMouseUp={mouseUpHandler} onMouseMove={mouseMoveHandler}
                    >
                        {years && years.length > 0 ? (
                            years.map((year) => (
                                <button
                                    key={year}
                                    className={`${styles.year_item} ${activeYear === year ? styles.active : ''}`}
                                    onClick={() => {
                                        setActiveYear(year); // 활성화된 년도 변경
                                    }}
                                >
                                    {year}
                                </button>
                            ))
                        ) : (
                            <div></div>
                        )}
                    </div>
                </div>
                <div className={styles.history_detail_box}>
                    <div>
                        {filteredEvents ? (
                            filteredEvents.events.map((event, index) => (
                                <div className={styles.his_m_box} key={index}>
                                    <span className={styles.his_m}>{event.month.toString().padStart(2, '0')}</span>
                                    <div className={styles.his_m_list_box}>
                                        {event.detail.map((detail, idx) => (
                                            <div className={styles.his_m_list} key={idx}>
                                                <span className={styles.his_m_tit}>{detail.description}</span>
                                                <span className={styles.his_m_date}>{detail.dateTxt}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>연도를 선택해주세요.</p>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ActivityHistory;